import { Lock, LockPolicy } from "../common/types/lock";
import { queryClient, locksQueryKey } from "../queryClient";
import { lockContract } from "../common/contracts/lock.contract";
import { getBackendAPIClient } from "./backendAPIClient";

export const lockContractClient = getBackendAPIClient(lockContract);

export async function getLock(entityId?: number | null): Promise<Lock[]> {
    if (!entityId) {
        return [];
    }

    const {
        body: { locks },
    } = await lockContractClient.getLock({
        params: { entityId: String(entityId) },
    });

    return locks;
}

export async function getLocks(entityIds: number[]): Promise<Lock[]> {
    if (entityIds.length === 0) {
        return [];
    }

    const response = await lockContractClient.getLocks({
        query: { entityIds },
    });

    return response.body.locks;
}

export async function updateLock({
    date,
    entityId,
    policy,
}: {
    date: string | null;
    entityId: number;
    policy: LockPolicy;
}) {
    const {
        body: { locks },
    } = await lockContractClient.updateLock({
        params: { entityId: String(entityId) },
        body: { date, policy },
    });

    queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === locksQueryKey,
    });

    return locks;
}
